export default __webpack_public_path__ + "static/media/programs-reproductive.3fc48653.png";